import {
  UndecoratedFinancialReport,
  UndecoratedInvestment,
} from '@flemingmetrics/api-client';
import { sumInvestments } from '@/utils/reports';

export function getSummary(
  { shareCount, price }: UndecoratedInvestment,
  latestFinancialReport?: UndecoratedFinancialReport
) {
  return sumInvestments(
    [{ shareCount, price: parseFloat(price) }],
    latestFinancialReport
  );
}
